import type { JobLog, RecentComment } from '@techgitter/contracts';

export type DisplayLogEntry =
  | { kind: 'log'; log: JobLog }
  | { kind: 'comment'; id: number; text: string; subject: string; createdAt: string; createdBy: string };

function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, '').trim();
}

/**
 * Merge job log entries with recent RS comments into a single
 * chronologically-sorted timeline.
 */
export function mergeLogsWithComments(
  logs: JobLog[],
  comments: RecentComment[] | undefined,
): DisplayLogEntry[] {
  const logEntries: DisplayLogEntry[] = logs.map(log => ({ kind: 'log', log }));
  const commentEntries: DisplayLogEntry[] = (comments ?? []).map(c => ({
    kind: 'comment',
    id: c.id,
    text: stripHtml(c.body),
    subject: c.subject,
    createdAt: c.createdAt,
    createdBy: c.tech,
  }));

  return [...logEntries, ...commentEntries].sort((a, b) => {
    const dateA = a.kind === 'log' ? a.log.createdAt : a.createdAt;
    const dateB = b.kind === 'log' ? b.log.createdAt : b.createdAt;
    return new Date(dateB).getTime() - new Date(dateA).getTime();
  });
}
